<template>
        <Preloader v-if="isLoading ||!filters || !locations">
          <!-- <pre>{{ JSON.stringify({ isLoading, filters },null,2) }}</pre> -->
        </Preloader>
        <main v-else class="wish-wrap">

        <div class="details-wrap">

            <!-- {{ dominantCity }} -->
            <!-- <pre>{{ JSON.stringify({ isLoading, filters },null,2) }}</pre> -->
            <!-- <pre>{{ JSON.stringify({ locationsByCity},null,2) }}</pre> -->
            <!-- <pre>{{ JSON.stringify({ dominantCity},null,2) }}</pre> -->

            <MyFilters />

            <!-- <pre>{{ JSON.stringify(filters.locationIds,null,2) }}</pre> -->
            <!-- <pre>{{ JSON.stringify(locationsByCity,null,2) }}</pre> -->

                 <div class="cell small-12">
        <p>Var söker du bostad?</p>


        <div class="city-chooser">
            <button @click.prevent="filterLocationSimple = 'stockholm'" :class="{ active: filterLocationSimple == 'stockholm' }"
>Stockholm <span class="counter" v-if="countByCitySlug('stockholm')">{{ countByCitySlug('stockholm') }}</span></button>
            <button @click.prevent="filterLocationSimple = 'goteborg'" :class="{ active: filterLocationSimple == 'goteborg' }">Göteborg <span class="counter" v-if="countByCitySlug('goteborg')">{{ countByCitySlug('goteborg') }}</span></button>
            <button @click.prevent="filterLocationSimple = 'malmo'" :class="{ active: filterLocationSimple == 'malmo' }">Malmö <span class="counter" v-if="countByCitySlug('malmo')">{{ countByCitySlug('malmo') }}</span></button>
            <button @click.prevent="filterLocationSimple = 'other'" :class="{ active: filterLocationSimple == 'other' }" style="white-space: nowrap;">Annan&nbsp;ort

              <span class="counter" v-if="nonCityLocationCount">{{ nonCityLocationCount}}</span>
              
            </button>
        </div>


        <div v-if="false" class="check-tag-wrap">
          <div
            class="check-tag "
            :class="{ active: filterLocationSimple == 'stockholm' }"
            @click="filterLocationSimple = 'stockholm'">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Stockholm
            </div>
          </div>

          <div
            class="check-tag "
            :class="{ active: filterLocationSimple == 'goteborg' }"
            @click="filterLocationSimple = 'goteborg'">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Göteborg
            </div>
          </div>

          <div
            class="check-tag "
            :class="{ active: filterLocationSimple == 'malmo' }"
            @click="filterLocationSimple = 'malmo'">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Malmö
            </div>
          </div>

          <div
            class="check-tag "
            :class="{ active: filterLocationSimple == 'other' }"
            @click="filterLocationSimple = 'other'">
            <div class="check-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8">
                <path
                  fill-rule="nonzero"
                  d="M7.68198052 1.31801905L3.08578644 5.91421312 1.31801948 4.14644617c-.19526188-.19526188-.51184631-.19526046-.70710678 0-.19526046.19526047-.19526188.5118449 0 .70710678L2.73223305 6.9748733c.19526258.19526258.51184631.19526046.70710678 0L8.3890873 2.02512583c.19526046-.19526047.19526258-.5118442 0-.70710678-.19526188-.19526188-.51184632-.19526047-.70710678 0z" />
              </svg>
            </div>
            <div class="check-label">
              Annan ort
            </div>
          </div>
</div>

     <div class="clear"></div>


          <div v-if="filterLocationSimple === 'goteborg'">
            <h3>Centrum</h3>
            <LocationCheckbox v-for="id in [151, 154, 148, 152, 153, 147, 150, 155, 149]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Majorna/Linné</h3>
            <LocationCheckbox v-for="id in [144, 140, 142, 146, 139, 145, 141, 138, 143]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Nordost</h3>
            <LocationCheckbox v-for="id in [92, 93, 85, 71,70]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Sydväst</h3>
            <LocationCheckbox v-for="id in [86, 90, 75]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Hisingen</h3>
            <LocationCheckbox v-for="id in [89, 91, 87]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>I närheten</h3>
            <LocationCheckbox v-for="id in [72, 73]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
          </div>
          <div v-if="filterLocationSimple === 'malmo'">
            <h3>Malmö</h3>
            <LocationCheckbox v-for="id in [131, 127, 128, 130, 129]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
          </div>
          <div v-if="filterLocationSimple === 'stockholm'">
              <h3>Innerstan</h3>
              <LocationCheckbox v-for="id in [137, 132, 135, 136, 133, 157, 156, 159, 11, 6]" :key="id" :locationId="id" /> 
              <div class="clear"></div>
              <h3>Söderort</h3>
              <LocationCheckbox v-for="id in [134, 63, 65, 64, 62, 15, 13, 35, 38, 39, 43, 44, 45, 49, 50]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Norrort</h3>
            <LocationCheckbox v-for="id in [10, 14, 36, 40, 55, 42, 46, 47, 48, 51, 52, 53, 54, 57]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Västerort</h3>
            <LocationCheckbox v-for="id in [58, 59, 60, 61, 37]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
            <h3>Nacka och Värmdö</h3>
            <LocationCheckbox v-for="id in [41, 56]" :key="id" :locationId="id" /> 
            <div class="clear"></div>
        </div>
        
        
        <div v-if="filterLocationSimple === 'other'">
            <!-- choose a län, then its kommuner (and their own sub-areas) as chips, like the city tabs (2026-10-19) -->
            <label class="region-select">
              <span>Välj län</span>
              <select v-model="otherRegionId">
                <option :value="null">Välj län …</option>
                <option v-for="r in otherRegions" :key="r.id" :value="r.id">{{ r.label }}{{ r.selected ? ' (' + r.selected + ' valda)' : '' }}</option>
              </select>
            </label>
            <LocationGroup v-if="otherRegion" :node="otherRegion" />


            </div>



        </div>
      </div>

       
        <div style="">
         
    <LMap
    
          v-if="true"
          ref="map"
          class="ad-map"
          :zoom.sync="zoom"
          :options="mapOptions"
          :min-zoom="minZoom"
          :max-zoom="maxZoom"
          :bounds="bounds"
            :max-bounds="maxBounds"
@ready="onMapReady"
          >
          <OpenFreeMapLayer />



            <!-- <LGeoJson ref="geojson" :geojson="wishGeoJSON"></LGeoJson> -->
            <!-- <LGeoJson v-for="feature in fullGeoJSON.features" :geojson="feature" :options="geoJsonOptions"></LGeoJson>-->
            <!-- <LGeoJson v-for="feature in wishGeoJSON.features" :geojson="feature" :options="geoJsonOptions"></LGeoJson> -->

            <LGeoJson 
  v-for="feature in wishGeoJSON.features" 
  :key="feature.properties.bb_id"
  ref="geojson"
  :geojson="feature" 
  :options="geoJsonOptions">

  <LTooltip :content="feature.properties.name || 'Unknown'" />
  <LPopup :content="feature.properties.name || 'Unknown'" />
</LGeoJson>

            <!-- <LGeoJson 
  v-for="(feature, index) in fullGeoJSON.features" 
  :key="feature.properties.bb_id"
  ref="geojson"
  :geojson="feature" 
  v-if="selectedLocationsAndTheirChildren().includes(feature.properties.bb_id)"
  :options="geoJsonOptions">
</LGeoJson> -->
          <!-- <LMarker :lat-lng="center" :icon="icon" /> -->
          <!-- <template v-for="(flat, index) in ad.flats">
            <LMarker v-if="index == currentFlat" :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="icon" @click="showflat(index)" />
            <LMarker v-else :key="flat.id" :lat-lng="{lat: flat.lat, lng: flat.lng}" :icon="iconInactive" @click="showflat(index)" />
          </template> -->
        </LMap>
</div>






    </main>
</template>



<style scoped lang="scss">
.region-select {
  display: block;
  margin: 1rem 0 .5rem;
  span { display: block; font-size: .85rem; color: #6b6f80; margin-bottom: .25rem; }
  select { width: 100%; max-width: 28rem; height: 3rem; border-radius: 999px; padding: 0 1.25rem; border: 1px solid #e6e8ec; background: #fff; font: inherit; }
}
// @import '@/scss/abstracts/_variables.scss';
// @import '@/scss/abstracts/_mixins.scss';
@import '@/scss/main.scss';


.counter{
    background-color: var(--color-secondary);
    color: white;
    border-radius: 1rem;
    padding: 3px 6px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    margin-left: 8px;
}

.city-chooser {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns by default */
  font-size: 17px;
  gap: 8px;
  background-color: #e5e5e5;
  border-radius: 1rem;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Switch to 2x2 grid on smaller screens */
@media (max-width: 1120px) {
  .city-chooser {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 640px) {
  .city-chooser {
    
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 520px) {
  .city-chooser {
    grid-template-columns: repeat(2, 1fr);
  }
}

.city-chooser button {
  padding: 12px 20px;
  font-weight: 600;
  font-size: 16px;
  background-color: transparent;
  color: #666;
  cursor: pointer;
  border: none;
  border-radius: 0.875rem;
  transition: all 0.2s ease;
  place-content:center;
  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
    color: #333;
  }
  
  &.active {
    background-color: #fff;
    color: #000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  display: flex;
}


.wish-wrap{
    display:grid;
    grid-template-columns: 1fr;
    grid-template-rows: 2fr 1fr;
    // margin-top: $header-height;
    // min-height: calc(100vh - #{$header-height});
    width:100%;
    margin-top: var(--header-height);
    height:100%;
    // background-color: red;
    height:var(--available-height);
    @media (min-width: 641px) {
grid-template-columns: min(50%, 700px) 1fr;
    grid-template-rows: 1fr;

    }
}

.details-wrap{
    background-color:#ffffff;
    // max-height: var(--available-height);
        padding:10px;

    overflow-y:scroll;
}
@media (min-width: 641px) {
    .details-wrap{
    // margin:25px;
    // border-radius:1rem;
    padding:25px;
    }

}
.page-wrap{
    background-color: #ffffff;
  padding:50px 0;

  @include breakpoint(small down){
      margin-top: $header-mob-height;
        min-height:calc(100vh - #{$header-mob-height + $nav-mob-height}); top:0px;
    }
}

ul{
  margin:0;
}
p, h3, h1, h2, ul{
  padding-bottom:20px;
}
h2,h3,h4{
  padding-top:20px;
}





</style>

<style>

.vue-treeselect{
    margin-top:25px;
}
.vue-treeselect input[type="email"], .vue-treeselect input[type="tel"], .vue-treeselect input[type="text"], .vue-treeselect input[type="password"]{
  /* font-size:17px; */
  /* border-radius: 0; */
  padding: 5px 0px;
  /* width:100%; */
  background-color: transparent;
  height:auto;
  margin-bottom:0;
  font-size:17px;
  font-weight: 600;
}

.vue-treeselect__control-arrow, .vue-treeselect__option-arrow {
  color:var(--color-secondary) ;
  fill:var(--color-secondary) ;
}
.vue-treeselect__multi-value-item{
background: #64BCB2;
color:white;
}
.vue-treeselect__value-remove svg{
  color: white;
  fill:white;
}
.vue-treeselect__control-arrow-container{
  /* width:32px; */
}

.vue-treeselect, .vue-treeselect__multi-value-label{
  /* font-size:17px; */
  /* font-weight:400; */
}

.vue-treeselect__input-container input{
  /* font-size:17px; */
  /* font-weight:400; */
  /* background-color: transparent; */
}

.vue-treeselect__value-remove > svg{
  /* width:10px; */
  /* height:10px; */
}

.vue-treeselect__control-arrow{
  /* width:24px; */
  /* height:24px; */
}

.vue-treeselect__control{
  /* padding: 0 30px; */
  /* background-color: #f7f7f7; */
/* border: 0; */
/* height:24px!important; */
}

.vue-treeselect__option-arrow{
  /* width:15px; */
  /* height:15px; */
} 

.vue-treeselect{
    /* height:24px!important; */
}
</style>

<script>
import MyFilters from '@/components/MyFilters.vue';
import LocationCheckbox from '@/components/LocationCheckbox.vue';
import LocationGroup from '@/components/LocationGroup.vue';
import MapView from '@/components/MapView.vue'
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import UserService from '@/services/UserService.js'
import Preloader from '@/components/Preloader'

import { geoJSON, latLngBounds } from 'leaflet'
import { LMap, LMarker, LGeoJson, LPopup, LTooltip } from 'vue2-leaflet'
import OpenFreeMapLayer from '@/components/OpenFreeMapLayer.vue'

// const bbaxios = axios.create({
//     baseURL:
//     localStorage.getItem('apiBase') || 'https://api.bytbostad.se/api/v1',
//     withCredentials: true,
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//       Token: localStorage.getItem('token') || ''
//     }
//   })


export default {
   
    




  components: {
    LocationCheckbox,
    LocationGroup,
    // LMap,
    // LTileLayer,
    // LMarker,
    // PhotoGrid,
    MyFilters,
    // MapView,
    LMap, OpenFreeMapLayer, LMarker, LGeoJson, LPopup, latLngBounds,LTooltip,Preloader
  },
  data() {
    return {
      featuredLocations: [
        {
          slug: 'stockholm',
          label: 'Stockholm',
          areas: [
            {
              label: 'Innerstan',
              locationIds: [137, 132, 135, 136, 133, 157, 156, 159, 11, 6]
            },
            {
              label: 'Söderort',
              locationIds: [134, 63, 65, 64, 62, 15, 13, 35, 38, 39, 43, 44, 45, 49, 50]
            },
            {
              label: 'Norrort',
              locationIds: [10, 14, 36, 40, 55, 42, 46, 47, 48, 51, 52, 53, 54, 57]

            },
            {
              label: 'Västerort',
              locationIds: [58, 59, 60, 61, 37]
            },
            {
              label: 'Nacka och Värmdö',
              locationIds: [41, 56]
            }
          ]
        },
        {
          slug: 'goteborg',
          label: 'Göteborg',
          areas: [
            {
              label: 'Centrum',
              locationIds: [151, 154, 148, 152, 153, 147, 150, 155, 149]
            },
            {
              label: 'Majorna/Linné',
              locationIds: [144, 140, 142, 146, 139, 145, 141, 138, 143]
            },
            {
              label: 'Nordost',
              locationIds: [92, 93, 85, 71,70]
            },
            {
              label: 'Sydväst',
              locationIds: [86, 90, 75]
            },
            {
              label: 'Hisingen',
              locationIds: [89, 91, 87]
            },
            {
              label: 'I närheten',
              locationIds: [72, 73]
            }
          ]
        },
        {
          slug: 'malmo',
          label: 'Malmö',
          areas: [
            {
              label: 'Malmö',
              locationIds: [131, 127, 128, 130, 129]
            }
          ]
        }
      ],



          mapReady: false, // Add this flag
      isLoading: true,
          isInitialMount: true, // ← Add this flag

    filterLocationSimple: null,
    otherRegionId: null,
        // fullGeoJSON: null,
        saveTimeout: null, // Add this to track the timeout

    //   center: { lat: 51.505, lng: -0.09 },
    
    maxBounds: latLngBounds([
        [55.3617373725, 11.0273686052],
        [69.1062472602, 23.9033785336]
      ]),
      opacity: 0.6,
      token: 'your token if using mapbox',
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
        scrollWheelZoom: true,
        dragging: !window.L.Browser.mobile,
        tap: false,
        noBlockingAnimations: true
      },
      zoom: 13,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: 'topleft',
      attributionPosition: 'bottomright',
      layersPosition: 'topright',
      attributionPrefix: 'Vue2Leaflet',
      imperial: false,
      Positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],

      icon: window.L.icon({
        iconUrl: '/img/marker.svg',
        iconSize: [35, 44],
        iconAnchor: [17.5, 44]
      }),

      iconInactive: window.L.icon({
        iconUrl: '/img/marker-disabled.svg',
        iconSize: [35, 44],
        iconAnchor: [17.5, 44],
        // opacity: 0.5
      }),
    bounds: latLngBounds([
        [55.3617373725, 11.0273686052],
        [69.1062472602, 23.9033785336]
      ]),
    



      geoJsonOptions: {
  style: (feature) => {
    return {
      weight: 1,
      color: '#64BCB2',
      opacity: 1,
      fillColor: '#64BCB2',
      fillOpacity: 0.2
    };
  },
//   onEachFeature: (feature, layer) => {
//     // Bind tooltip with the name
//     if (feature.properties && feature.properties.name) {
//       layer.bindTooltip(feature.properties.name, {
//         permanent: false,  // Only show on hover
//         direction: 'top',  // Position of tooltip
//         className: 'geojson-tooltip' // Optional: for custom CSS styling
//       });
//     }

//     layer.on({
//       mouseover: (e) => {
//         const layer = e.target;
//         layer.setStyle({
//           weight: 1,
//           color: '#ff7800',
//           fillOpacity: 0.3
//         });
//         layer.bringToFront();
//       },
//       mouseout: (e) => {
//         const layer = e.target;
//         layer.setStyle({
//           weight: 1,
//           color: '#3388ff',
//           fillOpacity: 0.2
//         });
//       },
//       click: (e) => {
//         const id = feature.properties.bb_id;
//         this.toggleFilterLocation(id);
//       }
//     });
//   }
}





    }
},

  methods: {


    countByCitySlug(slug){
      if(this.locationsByCity.find(city => city.slug === slug)){
        return this.locationsByCity.find(city => city.slug === slug).numberSelected
      }else{
        return;
      }
    },

    onMapReady() {
    // console.log('Map is ready');
    this.mapReady = true;
    // If we already have GeoJSON data, fit the map
    if (this.wishGeoJSON.features.length > 0) {
      this.fitMapToGeojson();
    }
  },

    saveFiltersImmediately() {
    // Clear any pending auto-save
    if (this.saveTimeout) {
      clearTimeout(this.saveTimeout);
      this.saveTimeout = null;
    }
    
    // Save immediately
    // return this.$store.dispatch('setFilters', this.filters);


    this.$store.commit('SET_PROSPECTS', [])
      this.$store.commit('SET_PROSPECTS_LOADING', true)
      this.$store.dispatch('setFilters', this.filters).then(() => {
        this.$store.dispatch('updateProspects').then(() => {
          this.$store
            .dispatch('preLoadImages', this.prospectsPhotos)
            .then(() => {
              this.$store.commit('SET_PROSPECTS_LOADING', false)
            })
        })
      })
  },
  async loadMyGeoJsons() {
    try {
      // console.log('loadMyGeoJsons called', {
      //   hasFilters: !!this.filters,
      //   locationIds: this.filters && this.filters.locationIds,
      //   locationIdsLength: this.filters && this.filters.locationIds && this.filters.locationIds.length
      // });

      if (!this.filters || !this.filters.locationIds || this.filters.locationIds.length === 0) {
        // console.log('No location IDs to load');
        return;
      }

      // console.log('Fetching GeoJSON for IDs:', this.filters.locationIds);
      
      await this.$store.dispatch('fetchGeoJson', this.filters.locationIds);
      
      // console.log('GeoJSON fetched, wishGeoJSON features:', this.wishGeoJSON.features.length);
      
      // Only fit if map is ready
      if (this.mapReady) {
        await this.$nextTick();
        this.fitMapToGeojson();
      }
      
    } catch (error) {
      // console.error('Error loading GeoJSONs:', error);
    }
  },


updateFilters(){
    console.log('I ran updated filter in Wishes.vue')
      this.$store.commit('SET_PROSPECTS', [])
      this.$store.commit('SET_PROSPECTS_LOADING', true)
      this.$store.dispatch('setFilters', this.filters).then(() => {
        this.$store.dispatch('updateProspects').then(() => {
          this.$store
            .dispatch('preLoadImages', this.prospectsPhotos)
            .then(() => {
              this.$store.commit('SET_PROSPECTS_LOADING', false)
            })
        })
      })
    },

    handleResize() {
      this.fitMapToGeojson();
    },

    // getFullGeoJson(){
    //     UserService.getGeoJson(0).then(response => {
    //         console.log(response);
    //         this.fullGeoJSON = response.data;  
    //     })
    // },

    //         this.$nextTick(() => {
    //   const map = this.$refs.map.mapObject;
      
    //   // Create a feature group from all GeoJSON layers
    //   const bounds = L.geoJSON(this.fullGeoJSON).getBounds();

    // //   console.log({bounds})
      
    //   if (bounds.isValid()) {
    //     map.fitBounds(bounds, {
    //       padding: [50, 50]
    //     });
    //   }
    // });
// });


//     },
  async getGeoJson(id){
  await this.$store.dispatch('fetchGeoJson', id);
  
  this.$nextTick(() => {
    this.fitMapToGeojson();
  });
},

   // Fit the map to the chosen areas of the open tab (Stockholm, Göteborg, Malmö, or the län chosen under
   // "Annan ort"); with nothing chosen there, to the whole tab. Choices in other cities do not zoom the map
   // out to half of Sweden (Fabian, 2026-10-19).
   async fitMapToGeojson() {
    if (!this.$refs.map) return;
    try {
      const tabIds = this.tabAreaIds;
      const chosen = new Set((this.filters && this.filters.locationIds) || []);
      const inTab = tabIds.filter(id => chosen.has(id));
      let features = inTab.length ? this.$store.getters.getGeoJsonsByIds(inTab) : [];
      if (!features.length && tabIds.length) {
        // nothing chosen here yet: show the whole tab (one /geo call returns an area and all areas under it)
        try { await this.$store.dispatch('fetchGeoJson', tabIds); } catch (e) { /* the map just stays */ }
        features = this.$store.getters.getGeoJsonsByIds(tabIds);
      }
      if (!features.length) features = this.wishGeoJSON.features;
      if (!features.length) return;
      const bounds = L.geoJSON({ type: 'FeatureCollection', features }).getBounds();
      if (bounds.isValid()) this.$refs.map.mapObject.fitBounds(bounds, { padding: [0, 0] });
    } catch (error) {
      console.error('Error fitting map to geojson:', error);
    }
  }
  },
  computed: {



    ...mapGetters(['prospectsPhotos', 'selectedLocationsAndTheirChildren', 'dominantCity']),
    ...mapState(['filters', 'locations']),

    locationIds(){
        return this.filters.locationIds;
    },

    locationsByCity(){


      return this.featuredLocations.map(location => {
  return {
    slug: location.slug,
    areas: location.areas.flatMap(area => area.locationIds),
    numberSelected: location.areas.flatMap(area => area.locationIds).filter(id => this.filters.locationIds.includes(id)).length
  }
})
      

    },

    // the top-level areas (län and the old groups) for "Annan ort", with how many chosen areas lie in each
    otherRegions(){
      const chosen = new Set(this.filters && this.filters.locationIds ? this.filters.locationIds : [])
      const count = (n) => (chosen.has(n.id) ? 1 : 0) + (n.children || []).reduce((s, c) => s + count(c), 0)
      // Stockholm and Göteborg have their own tabs (ids 1 and 68); Skåne stays – the Malmö tab is only Malmö
      return (this.locations || [])
        .filter(r => r.id !== 1 && r.id !== 68)
        .map(r => ({ id: r.id, label: r.label, selected: count(r), node: r }))
        .sort((a, b) => a.label.localeCompare(b.label, 'sv'))
    },
    // the area ids that belong to the open tab
    tabAreaIds(){
      if (this.filterLocationSimple === 'other') {
        if (!this.otherRegion) return [];
        const ids = [];
        const walk = n => { ids.push(n.id); (n.children || []).forEach(walk); };
        walk(this.otherRegion);
        return ids;
      }
      const city = this.featuredLocations.find(c => c.slug === this.filterLocationSimple);
      return city ? city.areas.flatMap(a => a.locationIds) : [];
    },
    otherRegion(){
      const r = this.otherRegions.find(x => x.id === this.otherRegionId)
      return r ? r.node : null
    },

    nonCityLocationCount(){

      let bigCityLocationIds = this.featuredLocations.map(location => location.areas.map(area => area.locationIds)).flat(Infinity);
      return this.filters.locationIds.filter(id => !bigCityLocationIds.includes(id)).length;
      // return {
      //   slug: 'other',
      //   areas: [],
      //   myFilterLocations: this.filters.locationIds,
      //   myFilterCount: 
      //   bigCityLocationIds

      //   // numberSelected: this.featuredLocations.map(location => {
      //   //   location.areas.flatMap(area => area.locationIds).filter(id => this.filters.locationIds.includes(id))
      //   // })
      // }

    },


    wishGeoJSON() {
  // console.log('wishGeoJSON computed', {
  //   hasFilters: !!this.filters,
  //   locationIds: this.filters && this.filters.locationIds,
  //   geojsons: Object.keys(this.$store.state.geojsons)
  // });

  if (!this.filters || !this.filters.locationIds || this.filters.locationIds.length === 0) {
    return { type: 'FeatureCollection', features: [] };
  }
  
  const features = this.$store.getters.getGeoJsonsByIds(this.filters.locationIds);
  
  // console.log('wishGeoJSON features:', features.length);
  
  return {
    type: 'FeatureCollection',
    features: features || []
  };
}

    // bounds() {

    //     return latLngBounds([
    //         [40.70081290280357, -74.26963806152345],
    //         [40.82991732677597, -74.08716201782228]
    //       ]);

    // }
//     //   return latLngBounds(this.ad.flats.map(flat => ([ flat.lat, flat.lng ]))).pad(0.2)

//     const bounds = [
//     [55.3617373725, 11.0273686052], // Southwest corner
//     [69.1062472602, 23.9033785336]  // Northeast corner
//   ];
//   return bounds;
  
//   // Fit the map to these bounds
// //   this.map.fitBounds(bounds);


//       return new L.LatLngBounds({ lat: 51.505, lng: -0.09 })
//       // return this.ad.flats.map(flat => ([ flat.lat, flat.lng ]))
//     }
  },
  watch:{
    // a new tab or län: fit the map to what belongs to it
    filterLocationSimple() { this.$nextTick(() => this.fitMapToGeojson()); },
    otherRegionId() { this.$nextTick(() => this.fitMapToGeojson()); },
    // open "Annan ort" on the län where most of the visitor's chosen areas are, once the tree and the
    // wishes have loaded (Stockholm and Göteborg have their own tabs)
    otherRegions(list) {
      if (this.otherRegionId !== null) return
      const withChoices = list.filter(r => r.selected)
      if (withChoices.length) this.otherRegionId = withChoices.sort((a, b) => b.selected - a.selected)[0].id
    },
    'wishGeoJSON.features.length': function(newLength, oldLength) {

      console.log('wishGeoJSON.features.length changed from', oldLength, 'to', newLength);
    if (newLength > 0 && this.mapReady && newLength !== oldLength) {
      this.$nextTick(() => {
        this.fitMapToGeojson();
      });
    }
  },
   
    locationIds(newVal, oldValue) {
        const isNew = JSON.stringify(newVal) !== JSON.stringify(oldValue);
        // console.log({newVal, oldValue, isNew})
        if(isNew){
          if (this.isInitialMount) {
        console.log('Skipping auto-save during initial mount');
        return;
      }

        // Clear existing timeout
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }


        // Set new timeout to save after 5 seconds
        this.saveTimeout = setTimeout(() => {
            console.log('Auto-saving filters...');
            this.$store.dispatch('setFilters', this.filters)
            .then(() => console.log('Filters saved!'))
            .catch(err => console.error('Save failed:', err));
        }, 5000);
    
     // Update map
      if(newVal.length === 0){
        this.$nextTick(() => {
          this.$refs.map.mapObject.fitBounds(this.bounds, {
            padding: [0,0]
          });
        });
      } else {
        this.getGeoJson(newVal)
      }
  }
  }
},
    async mounted() {
  // console.log('Mounted Wishes.vue');
  
  try {
    // Load filters and locations in parallel
    await Promise.all([
      this.filters ? Promise.resolve() : this.$store.dispatch('getFilters'),
      this.$store.dispatch('getLocations')
    ]);

    // Now both filters and locations are guaranteed to be loaded
    await this.$nextTick();
    
    // Now dominantCity should work
    this.filterLocationSimple = this.$store.getters.dominantCity || 'other';
    // console.log('dominantCity in Wishes.vue mounted', this.filterLocationSimple);
    
    // Load GeoJSON data
    await this.loadMyGeoJsons();

    // Add resize listener
    window.addEventListener('resize', this.handleResize);
    
    // Initial fit if needed
    this.$nextTick(() => {
      this.fitMapToGeojson();
    });
    
    // Allow auto-save after initial mount is complete
    this.$nextTick(() => {
      this.isInitialMount = false;
    });
    
  } catch (error) {
    // console.error('Error in mounted:', error);
    Sentry.captureException(error);
  } finally {
    this.isLoading = false;
  }
},
  deactivated() {
      // console.log('component is being kept alive in cache for now')
    },
  beforeDestroy() {
    // console.log('Wishes.vue beforeDestroy - saving filters immediately');
    this.saveFiltersImmediately();
    // Clean up the listener to prevent memory leaks
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>
